/* Represent-inspired drawer for Dawn. Call window.RepresentCart.open() after a successful cart add. */
(() => {
  if (window.RepresentCart) return;
  const root = document.getElementById('rep-cart');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const base = route.endsWith('/') ? route : `${route}/`;
  const money = (cents, currency) => {
    const code = currency || root.dataset.currency || 'USD';
    try { return new Intl.NumberFormat(root.dataset.locale || 'en-US', {style:'currency',currency:code}).format(cents/100); }
    catch { return `${(cents/100).toFixed(2)} ${code}`; }
  };
  const safe = (s) => String(s ?? '').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  let latest = null, previousFocus = null, loading = false;
  function updateBadges(cart) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(el => {el.textContent=cart.item_count;});
    document.querySelectorAll('.cart-count-bubble').forEach(el => {el.style.display=cart.item_count ? '' : 'none';});
  }
  function render(cart) {
    latest = cart;
    $('[data-rep-count]').textContent = cart.item_count;
    $('[data-rep-subtotal]').textContent = money(cart.items_subtotal_price, cart.currency);
    $('[data-rep-total]').textContent = money(cart.total_price, cart.currency);
    const threshold = Number(root.dataset.threshold) || 0;
    const remaining = Math.max(0,threshold-cart.total_price);
    $('[data-rep-bar]').style.width = `${threshold ? Math.min(100,cart.total_price/threshold*100):100}%`;
    $('[data-rep-shipnote]').textContent = remaining ? `Spend ${money(remaining,cart.currency)} more to qualify for free shipping` : "You've unlocked free shipping";
    $('[data-rep-shipping-value]').textContent = remaining ? 'Not yet unlocked' : 'Free';
    $('[data-rep-items]').innerHTML = cart.items.length ? cart.items.map((item,index) => {
      const options = item.options_with_values.filter(o => o.value && o.value !== 'Default Title').map(o => safe(o.value)).join('  ');
      const image = item.image ? `<img src="${safe(item.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_220x$1$2'))}" alt="${safe(item.product_title)}" loading="lazy">` : '';
      return `<article class="rep-cart__item"><a class="rep-cart__item-image" href="${safe(item.url)}">${image}</a><div class="rep-cart__item-main"><div class="rep-cart__item-head"><a href="${safe(item.url)}">${safe(item.product_title)}</a><span>${money(item.final_line_price,cart.currency)}</span></div><div class="rep-cart__item-options">${options}</div><div class="rep-cart__item-actions"><div class="rep-cart__qty"><button type="button" data-rep-change="${index+1}" data-qty="${item.quantity-1}" aria-label="Decrease quantity">−</button><b>${item.quantity}</b><button type="button" data-rep-change="${index+1}" data-qty="${item.quantity+1}" aria-label="Increase quantity">+</button></div><button type="button" class="rep-cart__remove" data-rep-change="${index+1}" data-qty="0" aria-label="Remove ${safe(item.product_title)}">×</button></div></div></article>`;
    }).join('') : '<div class="rep-cart__empty">Your cart is empty. <a href="/collections/all">Continue shopping</a></div>';
    updateBadges(cart);
  }
  async function refresh(){
    const r=await fetch(`${base}cart.js`,{credentials:'same-origin',headers:{'Accept':'application/json'}});
    if(!r.ok) throw Error('Could not load the cart.');
    render(await r.json());
  }
  function error(message){const node=$('[data-rep-error]');node.textContent=message;node.hidden=false;}
  function open(){
    previousFocus=document.activeElement;
    root.hidden=false;document.body.classList.add('rep-cart-lock');
    $('[data-rep-error]').hidden=true;$('.rep-cart__panel').focus();
    refresh().catch(e=>error(e.message));
  }
  function close(){root.hidden=true;document.body.classList.remove('rep-cart-lock');if(previousFocus && previousFocus.focus)previousFocus.focus();}
  async function change(line,quantity){
    if(loading)return;loading=true;$('[data-rep-error]').hidden=true;
    try {
      const r=await fetch(`${base}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});
      const cart=await r.json();if(!r.ok)throw Error(cart.description || 'Could not update cart');render(cart);
    }catch(e){error(e.message);}finally{loading=false;}
  }
  async function add(variantId){
    if(loading)return;loading=true;$('[data-rep-error]').hidden=true;
    try {
      const r=await fetch(`${base}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})});
      const result=await r.json();if(!r.ok)throw Error(result.description || 'Could not add product');await refresh();
    }catch(e){error(e.message);}finally{loading=false;}
  }
  root.addEventListener('click',e=>{
    if(e.target.closest('[data-rep-close]')){close();return;}
    const qty=e.target.closest('[data-rep-change]');if(qty){change(Number(qty.dataset.repChange),Number(qty.dataset.qty));return;}
    const addBtn=e.target.closest('[data-rep-add]');if(addBtn){add(addBtn.dataset.repAdd);return;}
  });
  document.addEventListener('keydown',e=>{
    if(root.hidden)return;
    if(e.key==='Escape'){e.preventDefault();close();}
    if(e.key==='Tab'){
      const els=[...root.querySelectorAll('a[href],button:not([disabled]),summary')].filter(el=>el.getClientRects().length);
      if(!els.length)return;
      const first=els[0],last=els[els.length-1];
      if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
    }
  });
  // Intercept clicks on common Dawn cart-icon wrappers, not cart links inside our drawer.
  document.addEventListener('click',e=>{
    const anchor=e.target.closest('#cart-icon-bubble');
    if(anchor && !root.contains(anchor)){e.preventDefault();open();}
  },true);
  document.addEventListener('shopify:section:load',()=>{if(!root.hidden)refresh().catch(()=>{});});
  window.RepresentCart={open,close,refresh,add};
})();
